export const HAI_REDUCER_STATE_ID = 'hai' as const;
export const HAI_SEARCH_COMPONENTS = {
  filter: false,
  list: false,
};

export const HAI_ROUTE = '/hais';
